import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, ParamMap} from "@angular/router";
import {TowerService} from "../../api/service/tower.service";

@Component({
  selector: 'app-logitem',
  templateUrl: './logitem.component.html'
})
export class LogitemComponent implements OnInit {

  item: any;
  keys: any;

  constructor(private route: ActivatedRoute,
              private towerService: TowerService) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const itemId = params.get('id');

      this.towerService.recupererLogitem(itemId).subscribe(
        item => {
          this.item = item;
          this.keys = Object.keys(item);
        },
            error => alert('Erreur durant le chargement des données')
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/page/logitem/logitem.component.ts